import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import { useRef, useState } from "react";
import { Col, FloatingLabel, Form, Modal, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import useOrder from "../../../context/OrderContext";
import { addAccessorial, deleteAccessorial, editAccessorial, useGetAccessorialQuery } from "../../../features/accessorial/accessorialDetailSlice";

const Addaccessorial = () => {
  const { data: accessorialList } = useGetAccessorialQuery()
  const { accessorialLists } = useOrder();
  const dispatch = useDispatch();
  const textRef = useRef(null);
  const [isShow, setIsShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [addAccessorialList, setAddAccessorialList] = useState([])
  const [editingTaskIndex, setEditingTaskIndex] = useState(null);

  const Accessorialhandler = (e) => {
    setAddAccessorialList(addAccessorialList => ({ ...addAccessorialList, [e.target.name]: e.target.value }));
  }

  const accessorailHandler = (e) => {
    e.preventDefault();
    if (Object.keys(addAccessorialList).length === 0) {
      toast.info("Please fill the form", {
        position: "top-center",
      })
    }
    else if (editingTaskIndex === null) {
      if (accessorialLists.some((data) => data.accessorialID === addAccessorialList.accessorialID)) {
        toast.warn("Accessorial charge Added Already !", {
          position: "top-right",
        })
        return;
      }
      else {
        dispatch(addAccessorial(addAccessorialList));
      }
    } else {
      let editingItem = accessorialLists[editingTaskIndex];
      editingItem = addAccessorialList;
      dispatch(editAccessorial(editingItem));
    }
    setAddAccessorialList({ accessorialID: "", fuel: "" });
    setEditingTaskIndex(null);
    setIsUpdate(false)
  };


  const editAccessorialList = (id) => {
    let newEditItem = accessorialLists.find((data) => {
      return data.id === id
    });
    setIsUpdate(true);
    setAddAccessorialList(newEditItem)
    setEditingTaskIndex(id);
  }


  return (
    <>
      <Modal
        size="lg"
        show={isShow}
        onHide={() => setIsShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        id="product-desp"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {" "}
            Add Accessorial
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <fieldset className="">
            <Row>
            </Row>
            <Row className="mb-3 mt-1">
              <div className="add-access">
                <Row>
                  <Col>
                    {!isUpdate ?
                      <div className="addaccessrial_btn">
                        <button type="button" className="btn" onClick={accessorailHandler}><AddCircle /></button>
                      </div>
                      :
                      <div className="addaccessrial_btn">
                        <button type="button" className="btn" onClick={accessorailHandler}><Save /></button>
                      </div>
                    }
                  </Col>
                </Row>
              </div>
              <Form>
                <div className="section_back">
                  <Row className="mt-2 mb-3" >
                    <Col sm={4}>
                      <Form.Group controlId="Vehicle">
                        <FloatingLabel controlId="floatingSelectGrid" label="Accesorial Charge Description">
                          <Form.Select aria-label="Floating label select example" name="accessorialID" value={addAccessorialList.accessorialID || ""} onChange={(e) => { Accessorialhandler(e) }} required>
                            <option>Select</option>:
                            <>
                              {
                                accessorialList?.data?.map((data, index) => (
                                  <option key={index} value={data?.accessorialID}>{data?.description}</option>
                                ))
                              }
                            </>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <div className="form-floating">
                        <Form.Control type="text" autoComplete="off" placeholder="Amount" name="rate" value={addAccessorialList.rate || ""} onChange={(e) => { Accessorialhandler(e) }} required />
                        <label htmlFor="contact">Amount</label>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="fieldset-inner">
                        <label className="label-heading">Add fuel</label>
                        <div className="floating-checbox">
                          <div className="RadioButton">
                            <div className="usefuel-yes">
                              <input ref={textRef} value="Yes" type="radio" name="fuel" checked={addAccessorialList.fuel === "Yes"} onChange={(e) => { Accessorialhandler(e) }} />
                              <label>YES</label>
                            </div>
                            <div className="usefuel-no">
                              <input ref={textRef} value="No" type="radio" name="fuel" checked={addAccessorialList.fuel === "No"} onChange={(e) => { Accessorialhandler(e) }} />
                              <label>NO</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Row>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Accessorial Charge Description</th>
                        <th>Amount</th>
                        <th>Add fuel</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accessorialLists?.length > 0 && accessorialLists.map((data, id) => {
                        return (
                          <tr key={data.id}>
                            <td>
                              <div className="action_btn">
                                <span className="edit_btn" onClick={() => { editAccessorialList(data.id) }}><Edit /></span>
                                <span className="del_btn" onClick={() => dispatch(deleteAccessorial(data.id))}><Delete /></span>
                              </div>
                            </td>
                            <td>{data.accessorialID === '1' ? "Appointment" : data.accessorialID === '2' ? "Inside Delivery" : data.accessorialID === '3' ? "Tailgate" : ""}</td>
                            <td>{data.rate}</td>
                            <td>{data.fuel}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </Row>
              </Form>

            </Row>
          </fieldset>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Addaccessorial;
